import React, { useContext, useEffect, useState } from 'react';
import { Row, Form, message, Spin } from 'antd';
import moment from 'moment';
import EditForm from '../../../../components/EditForm';
import {
  ButtonCancelar,
  ButtonSalvar,
  DivButtons,
  DivItems,
} from '../../../../components/EditForm/styles';
import { toDate } from '../../../../helpers/utils';
import { EditorContext } from '../../EditorContext/editorContext';
import api from '../../../../services/api';
import { getEstadosList } from '../../../../services/estado';
import { getMarcasList } from '../../../../services/marcaModelo';
import { getCoresList } from '../../../../services/cor';
import { getTiposCarroceriasList } from '../../../../services/tipoCarroceria';
import { dateMask } from '../../../../helpers/helpersEditForm';

export default function InfoVeiculoEdicao({
  item,
  setReadOnly,
  carregarSolicitacaoAtual,
}) {
  const [form] = Form.useForm();
  const { lockButton, setLockButton } = useContext(EditorContext);
  const [loading, setLoading] = useState(false);
  const [listTipoCarroceria, setListTipoCarroceria] = useState([]);
  const [listCores, setListCores] = useState([]);
  const [listEstados, setListEstados] = useState([]);

  const ufLicenciamento = item?.cidadeLicenciamento.split('-')[1].trim();

  const initialState = async () => {
    try {
      const responseEstados = await getEstadosList();
      const responseCores = await getCoresList();
      const responseCarroceria = await getTiposCarroceriasList();
      setListCores(responseCores.cores);
      setListEstados(responseEstados.items);
      setListTipoCarroceria(responseCarroceria.tiposCarroceria);
    } catch (error) {}
  };
  useEffect(() => {
    initialState();
  }, []);

  const getCodigoEDescricaoForm = field => String(field).split('#');

  const existeCodigoEDescricao = array => array.length === 2;

  const getCodigoEDescricaoArray = array => ({
    codigo: parseInt(array[0]),
    descricao: array[1],
  });

  const salvarEdicao = async form => {
    const arrayCodigoIbgeENome = getCodigoEDescricaoForm(
      form.cidadeLicenciamento
    );
    let codigoIBGECidadeLicenciamento;
    let cidadeLicenciamento;

    const arrayCodigoDescricaoCarroceria = getCodigoEDescricaoForm(
      form.carroceria
    );
    let carroceria;
    let idCarroceria;

    if (existeCodigoEDescricao(arrayCodigoIbgeENome)) {
      const { codigo, descricao } = getCodigoEDescricaoArray(
        arrayCodigoIbgeENome
      );
      codigoIBGECidadeLicenciamento = codigo;
      cidadeLicenciamento = descricao;
    }

    if (existeCodigoEDescricao(arrayCodigoDescricaoCarroceria)) {
      const { codigo, descricao } = getCodigoEDescricaoArray(
        arrayCodigoDescricaoCarroceria
      );
      idCarroceria = codigo;
      carroceria = descricao;
    }

    const payload = {
      placa: form.placa,
      chassi: form.chassi,
      renavam: form.renavam,
      numeroCRLV: form.numeroCRLV,
      cor: form.cor,
      marca: form.marca,
      modelo: form.modelo,
      idCarroceria,
      carroceria: carroceria ?? item?.carroceria,
      tipo: form.tipo,
      anoFabricacao: form.anoFabricacao,
      anoModelo: form.anoModelo,
      codigoIBGECidadeLicenciamento,
      cidadeLicenciamento,
      codigoIBGEEstadoLicenciamento: form.codigoIBGEEstadoLicenciamento,
      ufEstadoLicenciamento: form.ufEstadoLicenciamento,
      dataLicenciamento: toDate(form.dataLicenciamento),
    };
    setLoading(true);
    try {
      await api.post('veiculo', payload);
      await carregarSolicitacaoAtual();
      setReadOnly(true);
      setLockButton(false);
      setLoading(false);
      return message.success('Dados do veículo atualizado com sucesso!');
    } catch (error) {
      setLoading(false);
      return message.error('Erro ao atualizar os dados do veículo.');
    }
  };

  const handleCancel = () => {
    setReadOnly(true);
    setLockButton(false);
  };

  const veiculos = [
    {
      label: 'Placa',
      nome: 'placa',
      width: '32%',
      initialValue: item?.placa || null,
      bloqueado: true,
      border: '1px solid #EFEFEF',
    },
    {
      label: 'Renavam',
      nome: 'renavam',
      width: '32%',
      initialValue: item?.renavam || null,
    },
    {
      label: 'Chassi',
      nome: 'chassi',
      width: '32%',
      initialValue: item?.chassi || null,
    },
    {
      label: 'Marca',
      nome: 'marca',
      width: '32%',
      initialValue: item?.marca || null,
      bloqueado: true,
      border: '1px solid #EFEFEF',
    },
    {
      label: 'Modelo',
      nome: 'modelo',
      width: '32%',
      initialValue: item?.modelo || null,
      bloqueado: true,
      border: '1px solid #EFEFEF',
    },
    {
      select: 'single',
      label: 'Carroceria',
      nome: 'carroceria',
      width: '32%',
      initialValue: item?.carroceria || null,
      list: listTipoCarroceria,
      receberId: true,
    },
    {
      select: 'single',
      label: 'Cor',
      nome: 'cor',
      width: '32%',
      initialValue: item?.cor || null,
      list: listCores,
    },
    {
      select: 'single',
      label: 'Tipo',
      nome: 'tipo',
      width: '32%',
      initialValue: item?.tipo || null,
      bloqueado: true,
      border: '1px solid #EFEFEF',
    },
    {
      label: 'Ano fabricação',
      nome: 'anoFabricacao',
      width: '32%',
      initialValue: item?.anoFabricacao || null,
    },
    {
      label: 'Ano modelo',
      nome: 'anoModelo',
      width: '32%',
      initialValue: item?.anoModelo || null,
    },
    {
      label: 'Numero CRLV',
      nome: 'numeroCRLV',
      width: '32%',
      initialValue: item?.numeroCRLV || null,
    },
    {
      label: 'Data de licenciamento',
      nome: 'dataLicenciamento',
      width: '32%',
      initialValue: item?.dataLicenciamento
        ? moment(item?.dataLicenciamento).format('DD/MM/YYYY')
        : null,
      onChange: e => dateMask(e.target.value, form, 'dataLicenciamento'),
    },
    {
      select: 'double',
      firstId: 'ufLicenciamento',
      secondId: 'cidadeLicenciamento',
      firstLabel: 'UF licenciamento',
      secondLabel: 'Cidade licenciamento',
      nome: 'cidadeLicenciamento',
      width: '65%',
      firstInitialValue: ufLicenciamento,
      secondInitialValue: item?.cidadeLicenciamentoSemUF || null,
      list: listEstados,
    },
  ];

  return (
    <Spin
      spinning={loading}
      size="large"
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Row
        justify="space-between"
        style={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          marginTop: 32,
        }}
        tip="Atualizando dados, aguarde."
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={form => salvarEdicao(form)}
        >
          <DivItems>
            {veiculos.map((item, i) => (
              <EditForm key={i} item={item} list={item.list} form={form} />
            ))}
          </DivItems>

          <DivButtons>
            <Form.Item>
              <ButtonCancelar onClick={() => handleCancel()}>
                Cancelar
              </ButtonCancelar>
            </Form.Item>
            <Form.Item>
              <ButtonSalvar>Salvar</ButtonSalvar>
            </Form.Item>
          </DivButtons>
        </Form>
      </Row>
    </Spin>
  );
}
